import { Grid, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import CustomCard from "../../../components/CustomCard/CustomCard";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import Select from "../../../components/Select/Select";
import api from "../../../redux/actions/api";
import {
  getAppointmentsByVetIdAndDate,
  getAvailabilityByVetIdAndType,
  getClinicDashboardData,
  updateAppointmentStatusById,
  updateCancel,
  updateCompleted,
  updateFinalize,
} from "../../../redux/reducers/clinicSlice";
import { getVetHolidaysById } from "../../../redux/reducers/doctorSlice";
import { getMedicalHistoryByPetId } from "../../../redux/reducers/medicalHistorySlice";
import {
  getAllDatesFromArray,
  getUpcoming60Dates,
} from "../../../util/function";
import { superTailsClinicId } from "../../../util/server";
import BookAnAppointment from "../../CommonScreens/BookAppointmentment/BookAnAppointment";
import RescheduleReassign from "../../CommonScreens/RealschuleReassign/RescheduleReassign";
import MedicalHistoryView from "../ClinicPetDetails/MedicalHistory/MedicalHistoryView";
import "./Home.css";

const initBookValues = {
  bookingType: "Phone",
  consultationMode: "Physical",
  serviceType: null,
  reason: "",
  vetName: null,
  appointmentOption: "",
  date: new Date(),
};
const initErrors = { appointmentDate: "", appointmentTime: "", doctor: "" };
const initSearchValues = {
  Upcoming: "",
  "In Transit": "",
  Consultation: "",
  Billing: "",
  Completed: "",
};

const HomeVisit = ({ selectedVet, selectedTab, vets }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [petData, setPetData] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [selectTime, setSelectTime] = useState(null);
  const [delModVisible, setDelModVisible] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [rescheduleModVsble, setRescheduleModVsble] = useState(false);
  const [followUpModVsble, setFollowUpModVsble] = useState(false);
  const [selectTimeIdError, setSelectTimeIdError] = useState(false);
  const [assignVetModVisible, setAssignVetModVisible] = useState(false);
  const [assignVetvalues, setAssignVetValues] = useState({});
  const [holidayDates, setHolidayDates] = useState([]);
  const [errors, setErrors] = useState(initErrors);
  const [bookValues, setBookValues] = useState(initBookValues);
  const [isReassign, setIsReassign] = useState(true);
  const [searchValues, setSearchValues] = useState(initSearchValues);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const clinicHolidays = useSelector((state) => state?.clinic?.holidays);
  const dashboard = useSelector((state) => state.clinic.dashboard);
  const vetAvailbility = useSelector((state) => state?.clinic?.vetAvailability);
  const vetBookedApnts = useSelector((state) => state?.clinic?.vetBookedApnts);
  const { details: clinicDetails, facilities } = useSelector(
    (state) => state?.clinic
  );
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const profile = JSON.parse(user);

  useEffect(() => {
    if (
      isReassign ||
      !bookValues?.vetName?.value ||
      !bookValues?.date ||
      !bookValues?.appointmentOption
    ) {
      return;
    }
    if (bookValues?.appointmentOption === "Later") {
      dispatch(getVetHolidaysById(bookValues?.vetName?.value));
      dispatch(
        getAvailabilityByVetIdAndType({
          vetId: bookValues?.vetName?.value,
          type: bookValues?.consultationMode,
        })
      );
      dispatch(
        getAppointmentsByVetIdAndDate({
          vetId: bookValues?.vetName?.value,
          date: moment(new Date(bookValues?.date)).format("YYYY-MM-DD"),
          clinicId: profile?.id,
        })
      );
    }
  }, [
    bookValues?.vetName?.value,
    bookValues?.date,
    bookValues?.appointmentOption,
    bookValues?.consultationMode,
  ]);

  useEffect(() => {
    // Refetch the dashboard data whenever the selected veterinarian changes
    if (selectedTab === "Home") {
      const reqObj = { type: selectedTab };
      if (selectedVet?.value !== "All")
        reqObj.url = `&doctorId=${selectedVet?.value}`;
      dispatch(getClinicDashboardData(reqObj));
    }
  }, [selectedVet]);

  useEffect(() => {
    getHolidayDateList();
  }, [holidays, clinicHolidays, vetAvailbility]);

  const getHolidayDateList = () => {
    if (
      (holidays?.length === 0 || !holidays) &&
      (clinicHolidays?.length === 0 || !clinicHolidays) &&
      vetAvailbility?.every((li) => li?.status)
    ) {
      return setHolidayDates([]);
    }
    const vetDates = getAllDatesFromArray(holidays) ?? [];
    const cliHolidays =
      clinicHolidays?.map((hl) => {
        return hl?.date;
      }) ?? [];
    const unAvilableDates =
      vetAvailbility?.length > 0 ? getUpcoming60Dates(vetAvailbility) : [];
    const mergedArray = vetDates?.concat(cliHolidays, unAvilableDates);
    setHolidayDates(uniq(mergedArray));
  };

  const getAllClinicUserList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.status === "Y")
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const getOthersByType = (type) => {
    const reqType = type === "Grooming" ? "ROLE_GROOMER" : "ROLE_RADIOLOGY";
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.userRole === reqType)
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const getVetList = () => {
    return clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
  };

  const checkIsVet = (apntVetId = null) => {
    if (!apntVetId) return false;
    return clinicVets?.some((li) =>
      li?.doctorId === apntVetId && li?.userType?.length > 0
        ? li?.userType?.some((ut) => ut?.name === "ROLE_DOCTOR")
        : false
    );
  };

  const createModalOpen = (li, reAssign = false) => {
    setIsReassign(reAssign);
    setRescheduleModVsble(!rescheduleModVsble);
    setModalData(li);
  };

  const rescheduleModClose = () => {
    setIsReassign(false);
    setRescheduleModVsble(false);
    setModalData(null);
  };

  const createModalOpenFollowUp = (li) => {
    setFollowUpModVsble(!followUpModVsble);
    setModalData(li);
    setIsReassign(false);
    setBookValues(initBookValues);
  };

  const onCloseFollowUpMod = () => {
    setFollowUpModVsble(false);
    setRescheduleModVsble(false);
    setBookValues(initBookValues);
    setModalData(null);
    setSelectTime(null);
    setSelectTimeIdError(false);
    setErrors(initErrors);
  };

  const handleDelModClose = (li) => {
    setDelModVisible(!delModVisible);
    setModalData(li);
    setCancelReason("");
  };

  const navigatePetDetailsScreen = (appointment) => {
    navigate(`/clinic-pet-details`, { state: { appointment } });
  };

  const filterAppointmentsByVet = (typ) => {
    return dashboard?.[typ]?.filter((itm) => !itm?.appoinment?.inpatient);
  };

  const handleChangeCardSearchValue = (value, type) => {
    const reqObj = { ...searchValues, [type]: value };
    setSearchValues(reqObj);
  };

  const renderSection = (
    title,
    data,
    colorClass,
    sectionType,
    checkIn,
    threedots
  ) => {
    const filteredData = data?.filter((li) => {
      const search = searchValues?.[sectionType]?.toLowerCase();
      if (!search) return true;
      return (
        li?.appoinment?.petName?.toLowerCase()?.includes(search) ||
        li?.appoinment?.userName?.toLowerCase()?.includes(search) ||
        li?.appoinment?.doctorName?.toLowerCase()?.includes(search)
      );
    });

    return (
      <div className="w20Per borderRight">
        <div className="flex-row">
          <div className="p10MinWid99Per ">
            <Typography
              className={`card-head-${colorClass}-color card-head-border-bottom-${colorClass} font-bold fs20`}
            >
              {title} ({data?.length ?? 0})
            </Typography>
            <CustomCard
              list={filteredData ?? []}
              dashboard
              sectionType={sectionType}
              onClickResch={(li) => createModalOpen(li, false)}
              onReassign={(li) => createModalOpen(li, true)}
              handleAction={(li) => handleAssignVet(li)}
              handleCancel={(li) => handleDelModClose(li)}
              handleCompleted={(li) => handleCompleted(li)}
              onFollowUp={(li) => {
                createModalOpenFollowUp(li);
              }}
              onClick={(li) => navigatePetDetailsScreen(li)}
              checkIn={false} //checkIn
              threedots={threedots}
              handleConsult={(li) => handleConsult(li)}
              handleCheckout={(li) => handleCheckout(li)}
              handleAdmit={(itm) => {}}
              searchValue={searchValues[sectionType]}
              onChangeSearchValue={handleChangeCardSearchValue}
            />
          </div>
        </div>
      </div>
    );
  };

  const handleAssignVet = (li) => {
    if (
      (clinicDetails?.id === li?.appoinment?.doctorId &&
        !checkIsVet(profile?.id)) ||
      !li?.appoinment?.facilityId
    ) {
      const reqVet =
        clinicDetails?.id === li?.appoinment?.doctorId &&
        !checkIsVet(profile?.id)
          ? null
          : clinicVets?.find(
              (vl) =>
                vl?.doctorId ===
                (checkIsVet(li?.appoinment?.doctorId)
                  ? li?.appoinment?.doctorId
                  : checkIsVet(profile?.id)
                  ? profile?.id
                  : null)
            );
      setAssignVetValues({
        vet:
          clinicDetails?.id === li?.appoinment?.doctorId &&
          !checkIsVet(profile?.id)
            ? null
            : {
                name: reqVet?.name ?? li?.appoinment?.doctorName,
                value: reqVet?.doctorId ?? li?.appoinment?.doctorId,
                id: reqVet?.doctorId ?? li?.appoinment?.doctorId,
              },
        facility: li?.appoinment?.facilityId
          ? {
              name: li?.appoinment?.facility ?? "",
              value: li?.appoinment?.facilityId,
              id: li?.appoinment?.facilityId,
            }
          : null,
      });
      setModalData(li);
      setAssignVetModVisible(true);
      return;
    } else {
      handleAction(
        li,
        checkIsVet(profile?.id) ? profile?.id : li?.appoinment?.doctorId,
        li?.appoinment?.facilityId,
        li?.appoinment?.facility
      );
    }
  };

  const handleAction = (
    li,
    vetId = null,
    facilityId = null,
    facilityName = null
  ) => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: li?.appoinment?.appointmentId,
        status: "intransit",
        successMsg: "Patient has been notified!",
        url: `&facilityId=${facilityId}&facilityName=${facilityName}&doctorId=${vetId}`,
      })
    ).then((res) => {
      if (res?.payload) {
        onCloseAssignVetMod();
        dispatch(getClinicDashboardData({ type: selectedTab }));
        // const data = { facilityId, facilityName, doctorId: vetId };
        // dispatch(
        //   clinicReassignAppointment({
        //     appointmentId: li?.appoinment?.appointmentId,
        //     data,
        //   })
        // )?.then((apiRes) => {
        //   if (apiRes?.payload) {
        //     onCloseAssignVetMod();
        //     dispatch(getClinicDashboardData({ type: selectedTab }));
        //   } else {
        //     onCloseAssignVetMod();
        //   }
        // });
      }
    });
  };

  const handleCancel = () => {
    dispatch(
      updateCancel({
        appId: modalData?.appoinment?.appointmentId,
        reason: cancelReason,
      })
    ).then((res) => {
      if (res?.payload) {
        setDelModVisible(false);
        setRescheduleModVsble(false);
        setCancelReason("");
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const onCloseAssignVetMod = () => {
    setAssignVetModVisible(false);
    setAssignVetValues({});
    setModalData(null);
  };

  const handleConsult = (li) => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: li?.appoinment?.appointmentId,
        status: "consultation",
        successMsg: "Status updated successfully!",
      })
    ).then((res) => {
      if (res?.payload) {
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const handleCompleted = (li) => {
    dispatch(updateFinalize(li?.appoinment?.appointmentId)).then((res) => {
      if (res?.payload) {
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const handleCheckout = (li, action) => {
    dispatch(updateCompleted(li?.appoinment?.appointmentId)).then((res) => {
      if (res?.payload) {
        if (
          profile?.createdBy === superTailsClinicId ||
          profile?.id === superTailsClinicId
        ) {
          dispatch(
            getMedicalHistoryByPetId({
              petId: li?.appoinment?.petId,
              url: `?type=all&page=1&itemSize=5`,
            })
          ).then((res2) => {
            if (res2?.payload?.data) {
              const apnt = li?.appoinment;
              setSelectedHistory(res2?.payload?.data?.[0]);
              setPetData({
                petName: apnt?.petName,
                breed: apnt?.breed,
                gender: apnt?.gender,
                dob: apnt?.dob,
                userName: apnt?.userName,
                petData: apnt?.mobile,
              });
            }
          });
        }
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const handleUploadComplete = async (url, apntId) => {
    await api({ contentType: true, auth: true })
      .get(`/appointment/${apntId}`)
      .then(async (getRes) => {
        if (getRes?.status === 200 || getRes?.status === 201) {
          if (getRes?.data?.data) {
            const reqObj = {
              appointment: {
                ...getRes?.data?.data,
                //  caseSummary: url
              },
            };
            try {
              // await superTailsApi.post("/appointment-completed", reqObj);
              setSelectedHistory(null);
              setPetData(null);
            } catch (supErr) {
              console.log("SuperTail Api Error", supErr);
            }
          }
        }
      });
  };

  const onAssignVetChange = (name, value, errName) => {
    setAssignVetValues({
      ...assignVetvalues,
      [name]: value,
      [errName]: value?.value ? false : true,
    });
  };

  const onAssignVet = () => {
    if (!assignVetvalues?.vet?.value || !assignVetvalues?.facility?.value) {
      return setAssignVetValues({
        ...assignVetvalues,
        error: !assignVetvalues?.vet?.value,
        facilityErr: !assignVetvalues?.facility?.value,
      });
    }
    handleAction(
      modalData,
      assignVetvalues?.vet?.value,
      assignVetvalues?.facility?.value,
      assignVetvalues?.facility?.name
    );
  };

  const getFacilitiesByType = () => {
    const reqType = "HomeKit";
    const reqVetList =
      facilities
        ?.filter((fl) => fl?.type === reqType)
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];
    return reqVetList;
  };

  return (
    <>
      <div className="flex-center">
        {renderSection(
          "Upcoming",
          filterAppointmentsByVet("upcomming"),
          "orange",
          "Upcoming",
          true,
          true
        )}
        {renderSection(
          "In Transit",
          filterAppointmentsByVet("intransit"),
          "rose",
          "Checked-in",
          true,
          true
        )}
        {renderSection(
          "Consultation",
          filterAppointmentsByVet("consultation"),
          "green",
          "Consultation",
          true,
          true
        )}
        {renderSection(
          "Billing",
          filterAppointmentsByVet("billings"),
          "yellow",
          "Billing",
          true,
          true
        )}
        {renderSection(
          "Completed",
          filterAppointmentsByVet("completed"),
          "paleGreen",
          "Completed",
          true,
          true
        )}
      </div>
      {selectedHistory ? (
        <MedicalHistoryView
          selectedHistory={selectedHistory}
          petData={petData}
          onUploadComplete={(e, apntId) => handleUploadComplete(e, apntId)}
        />
      ) : null}
      {followUpModVsble ? (
        <BookAnAppointment
          modalVisible={followUpModVsble}
          setBookModVisible={onCloseFollowUpMod}
          selectedPet={{
            petId: modalData?.appoinment?.petId,
            petName: modalData?.appoinment?.petName,
            petImage: modalData?.appoinment?.petImage,
            gender: modalData?.appoinment?.gender,
            breed: modalData?.appoinment?.breed,
            dob: modalData?.appoinment?.dob,
            userName: modalData?.appoinment?.userName,
            color: modalData?.appoinment?.color,
            weight: modalData?.appoinment?.weight,
            userMobile: modalData?.appoinment?.userMobile,
            mobile: modalData?.appoinment?.mobile,
          }}
          prevAppointmentId={modalData?.appoinment?.appointmentId}
        />
      ) : null}
      <RescheduleReassign
        open={rescheduleModVsble}
        onClose={rescheduleModClose}
        modalData={modalData}
        isReassign={isReassign}
        onSuccess={() => {
          dispatch(getClinicDashboardData({ type: selectedTab }));
        }}
        vets={vets}
        clinicVets={clinicVets}
        selectedTab={selectedTab}
      />

      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Cancel"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to cancel the appointment?
        </Typography>
        <div className="ml10 mt15">
          <CustomTextField
            label="Reason for cancellation"
            placeholder="Enter reason for cancellation (optional)"
            multiline
            rows={4}
            value={cancelReason}
            handleChange={(e) => setCancelReason(e.target.value)}
            fullWidth
          />
        </div>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton text="Yes" redBtn onClick={handleCancel} />
            </div>
            <div className="ml10">
              <CustomButton
                text={"No"}
                onClick={() => {
                  setDelModVisible(false);
                  setCancelReason("");
                }}
              />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={assignVetModVisible}
        onClose={onCloseAssignVetMod}
        header={
          modalData?.appoinment?.doctorId === clinicDetails?.id &&
          !checkIsVet(profile?.id) &&
          !modalData?.appoinment?.facilityId
            ? "Select Vet and Facility"
            : !modalData?.appoinment?.facilityId
            ? "Select Facility"
            : "Select Vet"
        }
        modal
        modalWidth={30}
      >
        <div className="mh10">
          {modalData?.appoinment?.doctorId === clinicDetails?.id &&
          !checkIsVet(profile?.id) ? (
            <div>
              <Select
                list={
                  modalData?.appoinment?.serviceType === "Grooming" ||
                  modalData?.appoinment?.serviceType === "Lab Tests" ||
                  modalData?.appoinment?.serviceType === "Radiology Tests"
                    ? getOthersByType(modalData?.appoinment?.serviceType)
                    : modalData?.appoinment?.serviceType === "Others"
                    ? getAllClinicUserList()
                    : getVetList()
                }
                handleChange={(e, value) =>
                  onAssignVetChange("vet", value, "error")
                }
                name="vet"
                label="Vet Name *"
                search
                value={assignVetvalues?.vet}
                error={!!assignVetvalues?.error}
                helperText={
                  assignVetvalues?.error ? "Vet Name is required field" : ""
                }
              />
            </div>
          ) : null}
          {!modalData?.appoinment?.facilityId ? (
            <div
              className={
                modalData?.appoinment?.doctorId === clinicDetails?.id &&
                !checkIsVet(profile?.id)
                  ? "mt15"
                  : ""
              }
            >
              <Select
                list={getFacilitiesByType()}
                handleChange={(e, value) =>
                  onAssignVetChange("facility", value, "facilityErr")
                }
                name="facility"
                label="Facility *"
                search
                value={assignVetvalues?.facility}
                error={!!assignVetvalues?.facilityErr}
                helperText={
                  assignVetvalues?.facilityErr
                    ? "Facility is required field"
                    : ""
                }
              />
            </div>
          ) : null}
          <div className="flex-center mv20">
            <div>
              <CustomButton text="Save" onClick={onAssignVet} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default HomeVisit;
